import { computed, onMounted, onUnmounted, ref } from 'vue';

class WindowResize {
  horizontalWindow() {
    let windowWidth = ref(window.innerWidth);

    const onWidthChange = () => (windowWidth.value = window.innerWidth);
    onMounted(() => window.addEventListener('resize', onWidthChange));
    onUnmounted(() => window.removeEventListener('resize', onWidthChange));

    const width = computed(() => windowWidth.value);

    return { width };
  }

  verticalWindow() {
    let windowHeight = ref(window.innerHeight);

    const onWidthChange = () => (windowHeight.value = window.innerHeight);
    onMounted(() => window.addEventListener('resize', onWidthChange));
    onUnmounted(() => window.removeEventListener('resize', onWidthChange));

    const height = computed(() => windowHeight.value);

    return { height };
  }

  resizeWindow() {
    let windowHeight = ref(window.innerHeight);
    let windowWidth = ref(window.innerWidth);

    const onChange = () => {
      windowHeight.value = window.innerHeight;
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => window.addEventListener('resize', onChange));
    onUnmounted(() => window.removeEventListener('resize', onChange));

    const height = computed(() => windowHeight.value);
    const width = computed(() => windowWidth.value);

    return { height, width };
  }
}

export default new WindowResize();
